import { Dock } from "lucide-react";
import {APP_BY_ID} from '../data/apps';
import {useDesktop} from '../desktop/DesktopContext';
import {AppIcon} from '../shell/AppIcon';
import {rememberLaunchOrigin} from './sheetMotion';

/** How many icons fit a phone dock without shrinking below the 44px target. */
const SLOTS = 4;

/**
 * The touch dock.
 *
 * Deliberately NOT the magnifying `<Dock>`: magnification is driven by pointer
 * distance, and a finger reports one position at a time — under it, and only
 * while it is already touching. What is left of the effect on touch is a dock
 * that scales items the user cannot see under their thumb, so this shell drops
 * it and spends the space on bigger targets instead.
 */
export function MobileDock() {
  const {dockOrder, openApp, windows} = useDesktop();
  const running = new Set(windows.map((win) => win.appId));

  const quick = dockOrder
    .map((id) => APP_BY_ID[id])
    .filter((app) => Boolean(app))
    .slice(0, SLOTS);

  return (
    <div className="safe-bottom pointer-events-none absolute inset-x-0 bottom-0 z-20 px-4 [--safe-extra:12px]">
      <div className="surface pointer-events-auto mx-auto flex max-w-sm items-center justify-around rounded-shell p-3">
        {quick.map((app) => (
          <button
            key={app!.id}
            type="button"
            aria-label={app!.name}
            onClick={() => openApp(app!.id)}
            data-app-icon={app!.id}
            onPointerDown={(event) => rememberLaunchOrigin(app!.id, event.currentTarget)}
            className="mobile-home-icon tap relative flex items-center justify-center rounded-card"
          >
            <span className="h-[52px] w-[52px]">
              <AppIcon app={app!} />
            </span>
            {running.has(app!.id) ? (
              <span className="absolute -bottom-1 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-accent" />
            ) : null}
          </button>
        ))}
      </div>
    </div>
  );
}
